@import "../../../styles/global";
@import "../../../styles/variables";
@import "node_modules/@se/web-ui/styles/_se-variable.scss";

.search {
  &__results-container {
    line-height: 27px;
    padding: 20px 16px 8px;
    @media (min-width: $tablet) {
      padding: 40px 18px 40px 15px;
    }

    &--autocorrect {
      @extend .search__results-container;
      padding-bottom: 25px;
      padding-left: 6px;
      min-height: 58px;
    }
  }

  &__results-text {
    font-size: 16px;
    font-weight: 400;
    color: $se-black;
    margin: 0;

    @media (min-width: $tablet) {
      font-size: 24px !important;
    }

    &--query {
      @extend .search__results-text;
      color: $se-black;
      font-weight: 600;
    }

    &--suggestion {
      @extend .search__results-text;
      color: $se-black;
      font-weight: 600;
      font-style: italic;
    }

    span {
      margin-right: 6px;
    }
  }

  &__results-text-autocorrect {
    font-size: 14px;
    font-weight: 400;
    color: $se-black;
    line-height: 26px;

    @media (min-width: $tablet) {
      font-size: 18px;
    }

    &--query-link {
      @extend .search__results-text-autocorrect;
      color: $uiass-link-color;
      border: none;
      background-color: inherit;
      margin: 0;
      padding: 0;
      cursor: pointer;
    }

    &--query-link:hover {
      text-decoration: underline;
    }

    &--query {
      @extend .search__results-text-autocorrect;
      color: $se-black;
      font-weight: 600;
    }

    &--space {
      @extend .search__results-text-autocorrect;
      margin-right: 8px;
    }
  }
}

.search__results-text--rtl,
.autocorrect--rtl {
  span {
    margin-right: 0;
    margin-left: 6px;
  }
}

.search__results-container--autocorrect {
  .loading__container {
    justify-content: flex-start;
  }
}

.autocorrect-srt--wrapper .search__results-container--autocorrect {
  padding-top: 13px;
  padding-bottom: 0;
  padding-right: 40px;
}

.autocorrect-srt--wrapper {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  @media (max-width: $tablet) {
    display: block;
  }
}

.autocorrect-srt {
  max-width: 400px;
  .search__results-text-autocorrect--query-link {
    text-align: left;
  }
}

.autocorrect-srt .search__results-text--srt,
.autocorrect-srt .search__no-results--autocorrect {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
